import React, { FC, useState } from "react";
import { Button, Modal, notification } from "antd";
import { Order } from "../queries/auto-generated/schemas";
import { useCancelOrderMutation } from "../queries/auto-generated/hooks";
import { useDispatch } from "react-redux";
import user from "../ducks/user";

const problemMessage =
  "There was a problem canceling the order. Please reach out to customer service if the problem continues.";

const CancelOrder: FC<{ order: Order }> = ({ order }) => {
  const dispatch = useDispatch();
  const [showCancelModal, setShowCancelModal] = useState<boolean>(false);
  const [cancelOrderMutation] = useCancelOrderMutation();
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleCancelOrder = () => {
    if (!order.square_id) {
      setErrorMessage(problemMessage);
    } else {
      setLoading(true);
      cancelOrderMutation({
        variables: {
          squareOrderId: order.square_id,
        },
      })
        .then(({ data }) => {
          if (data?.cancelOrder.order) {
            // Should only receive order object if cancellation was successful
            dispatch(user.actions.addOrder(data.cancelOrder.order as Order));
            setShowCancelModal(false);
            notification.open({
              message: "The order was successfully canceled.",
              placement: "bottomRight",
            });
          } else {
            setErrorMessage(problemMessage);
          }
        })
        .catch((e) => {
          console.error({ e });
          setErrorMessage(problemMessage);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleGoBack = () => {
    setShowCancelModal(false);
  };

  /* if (!loggedIn) {
    return (
      <Center>
        If you would like to cancel an order, please{" "}
        <a href="#login" onClick={handleLogin}>
          login
        </a>
        .
      </Center>
    );
  } */

  return (
    <>
      <Button
        block
        type="text"
        shape="round"
        onClick={() => setShowCancelModal(true)}
        loading={loading}
      >
        Cancel order
      </Button>
      <Modal
        visible={showCancelModal}
        title={`Are you sure you want to cancel order #${order.receipt_number?.toUpperCase()}?`}
        onCancel={handleGoBack}
        footer={null}
      >
        <p>
          This order may only be canceled before the "preparing order" step has
          begun.
        </p>
        <div style={{ color: "red" }}>{errorMessage}</div>
        <Button
          block
          shape="round"
          type="primary"
          onClick={handleGoBack}
          disabled={loading}
        >
          No, go back
        </Button>
        <Button
          block
          shape="round"
          onClick={handleCancelOrder}
          loading={loading}
          style={{ marginTop: "1em" }}
        >
          Yes, cancel order
        </Button>
      </Modal>
    </>
  );
};

export default CancelOrder;
